<ez-main-layout>
  <p>
    Ein Fehler ist aufgetreten, bitte entschuldigen Sie die Unnanehmlichkeiten und versuchen Sie es zu einem späteren
    Zeitpunkt erneut.
  </p>
  <p>
    Falls das Problem weiter besteht, wenden Sie sich gerne an uns. Die Kontaktdaten finden Sie in unserem Anschreiben.
  </p>
  <p><a routerLink="/">Zurück zur Startseite</a></p>
</ez-main-layout>
